import { EmailTemplateDetailsState } from "@idw-types/state/email-template-details-state";
import { EmailTemplateDetailsActions, EmailTemplateDetailsActionTypes } from "@redux/actions/email-template-details-actions";

export const initialEmailTemplateDetailsState: EmailTemplateDetailsState = {
    emailTemplate: {
        isLoading: false,
        emailTemplate: null
    }
};

export const emailTemplateDetailsReducer = (
    state: EmailTemplateDetailsState = initialEmailTemplateDetailsState,
    action: EmailTemplateDetailsActions
): EmailTemplateDetailsState => {
    switch (action.type) {
        // Email Template Details
        case EmailTemplateDetailsActionTypes.SET_EMAIL_TEMPLATE_DETAILS_LOADING:
            return {
                ...state,
                emailTemplate: {
                    ...(action.payload.isLoading
                        ? { ...initialEmailTemplateDetailsState.emailTemplate }
                        : { ...state.emailTemplate }),
                    isLoading: action.payload.isLoading
                }
            };
        case EmailTemplateDetailsActionTypes.SET_EMAIL_TEMPLATE_DETAILS:
            return {
                ...state,
                emailTemplate: {
                    emailTemplate: action.payload.emailTemplate,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};